var render = function render(){
  var _vm$value, _vm$value$employer, _vm$value$employer$in, _vm$value2, _vm$value2$employer, _vm$value2$employer$i;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-16 px-24",
    attrs: {
      "flat": "",
      "color": "grey-f1",
      "rounded": "lg"
    }
  }, [_c('p', {
    staticClass: "page--text text-center primary--text"
  }, [(_vm$value = _vm.value) !== null && _vm$value !== void 0 && (_vm$value$employer = _vm$value.employer) !== null && _vm$value$employer !== void 0 && (_vm$value$employer$in = _vm$value$employer.interview) !== null && _vm$value$employer$in !== void 0 && _vm$value$employer$in.isOnline ? [_c('span', [_vm._v(" 온라인 면접 ")])] : [_c('span', [_vm._v(" 면접장소: " + _vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$employer = _vm$value2.employer) === null || _vm$value2$employer === void 0 ? void 0 : (_vm$value2$employer$i = _vm$value2$employer.interview) === null || _vm$value2$employer$i === void 0 ? void 0 : _vm$value2$employer$i.location) + " ")])]], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }